import CcConstantSelector from './cc-constant-selector.vue';


/* 常量选择器，包含select 、 radio 两种模式 */
CcConstantSelector.install = function (Vue) {
    Vue.component(CcConstantSelector.name, CcConstantSelector);
};
export default CcConstantSelector;